(function () {
  const SCARCITY_MESSAGE = '🔥 Nur noch wenige verfügbar — Jetzt sichern!';

  // PDP (Ürün Sayfası)
  function initPDP() {
    const addToCartForm = document.querySelector('form[action="/cart/add"]');
    if (!addToCartForm) return;

    if (document.querySelector('.scarcity-indicator')) return;

    const indicator = document.createElement('p');
    indicator.className = 'scarcity-indicator';
    indicator.textContent = SCARCITY_MESSAGE;

    addToCartForm.insertAdjacentElement('afterend', indicator);
  }

  // Koleksiyon & Arama Kartları
  function initCards() {
    const cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    cards.forEach((card) => {
      if (card.querySelector('.scarcity-indicator--card')) return;

      const indicator = document.createElement('p');
      indicator.className = 'scarcity-indicator--card';
      indicator.textContent = SCARCITY_MESSAGE;

      const info = card.querySelector('.card__information, .card-information');
      if (info) info.appendChild(indicator);
    });
  }

  function init() {
    initPDP();
    initCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sayfa geçişleri için (View Transitions API)
  document.addEventListener('page:load', init);
})();
